import React, { useState, useEffect } from 'react';
import { Modal } from "bootstrap";
import { useMutation } from '@apollo/client';
import { START_CLIENT_INQUIRY } from "./mutations";
import { CONVERSATIONS_QUERY } from './queries';
import { useToastContext } from './context';
import { getCaseIdFromUrl } from './hooks';
import { TOASTS } from './shared/dictionary';

const AssignCsmModal = () => {
    const [selectedCsm, setSelectedCsm] = useState(null);

    useEffect(() => {
        const modal = document.getElementById('bs-assignCsmModal');

        const handleShow = (e) => {
            const selectedCsmId = modal?.getAttribute('data-selected-csm-id');
            const selectedCsmName = modal?.getAttribute('data-selected-csm-name');

            if (selectedCsmId && selectedCsmName) {
                setSelectedCsm({
                    id: selectedCsmId,
                    fullname: selectedCsmName,
                });
            }
        };

        modal?.addEventListener('show.bs.modal', handleShow);
        return () => modal?.removeEventListener('show.bs.modal', handleShow);
    }, []);

    return (
        <div
            className="modal fade"
            id="bs-assignCsmModal"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="bs-assignCsmModal"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Confirm CSM Assignment</h4>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to assign CSM to <span className="fw-bold">{selectedCsm?.fullname}</span>?</p>
                        <AssignCsmForm
                            selectedCsm={selectedCsm}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

const AssignCsmForm = ({ selectedCsm }) => {
    let caseId = getCaseIdFromUrl();
    const { showToast } = useToastContext();
    const [message, setMessage] = useState('');

    const [startClientInquiry, { loading }] = useMutation(START_CLIENT_INQUIRY, {
        onCompleted: () => handleSuccess(),
        onError: (error) => handleError(error),
        update(cache, { data: { startClientInquiry: { caseChat, agentLogs } } }) {
            const query = {
                query: CONVERSATIONS_QUERY,
                variables: {
                    caseId,
                },
            }
            const data = cache.readQuery(query);
            if (data) {
                cache.writeQuery({
                    ...query,
                    data: {
                        caseChats: !!caseChat ? [...data.caseChats, caseChat] : data.caseChats,
                        agentLogs: [...data.agentLogs, ...agentLogs],
                    }
                });
            }
        },
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        var variables = {
            id: caseId,
            params: {
                assignedCsmId: selectedCsm.id,
            }
        }
        startClientInquiry({ variables });
    }

    const handleClose = () => {
        var modal = Modal.getOrCreateInstance(document.getElementById('bs-assignCsmModal'));
        modal?.hide();
    };

    const handleSuccess = () => {
        showToast({ ...TOASTS.success, message: `Updated CSM to ${selectedCsm?.fullname}.`, });
        setMessage('');
        handleClose();

        // Scroll to end of messages
        const container = document.querySelector('#js-messagesContainer');
        if (container) {
            container.scrollTop = container.scrollHeight;
        }

        // Show alert to reload page
        const reloadPageAlert = document.querySelector('#js-reloadPageAlert');
        if (reloadPageAlert) {
            reloadPageAlert.classList.remove('d-none');
        }
    }

    const handleError = (error) => {
        showToast({ ...TOASTS.error, message: error.message });
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-end gap-4">
                <button
                    type="button"
                    className="btn btn-link-default btn-sm"
                    data-bs-dismiss="modal"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="btn btn-dark btn-sm"
                    disabled={loading}
                >
                    Confirm
                </button>
            </div>
        </form>
    );
}

export default AssignCsmModal;